
import { defineComponent, PropType } from 'vue'

type Tab = { id: number; name: string }

export default defineComponent({
    props: {
        value: {
            type: Number,
            default: null,
        },
        tabs: {
            type: Array as PropType<Tab[]>,
            default: () => [],
        },
        isSubTabs: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const onSelect = (tab: Tab) => {
            if (isTabSelected(tab)) return

            emit('update:value', tab.id)
            emit('change', tab.id)
        }

        const isTabSelected = (tab: Tab) => {
            if (!props.value) return false
            return props.value === tab.id
        }

        return {
            onSelect,
            isTabSelected,
        }
    },
})
